<script>
import formInput from "@/mixins/shared/formInput";

export default {
	mixins: [formInput],
	props: {
		'groupClasses': {
			type: String,
			required: false
		},
		'label': {
			type: String,
			required: false
		},
		'value': {
			required: false
		},
		'checked': {
			type: [Array, Boolean],
			default: false,
		},
	},
}
</script>

<template>
	<div :class="{'form-check': true,[groupClasses]: groupClasses}">
		<input
			v-bind="$attrs"
			type="radio"
			@input="$emit('update:modelValue', $event.target.value)"
			:name="name"
			:id="renderedId"
			:class="{'form-check-input': true, 'border-danger': hasError}"
			:value="value"
			:checked="modelValue == value"
		>
		<label v-if="label" :for="renderedId" :class="{'form-check-label': true, 'text-danger': hasError}">{{ label }}</label>
	</div>
</template>